import { render, staticRenderFns } from "./CampaignSetupsView.vue?vue&type=template&id=a62dc512"
import script from "./CampaignSetupsView.vue?vue&type=script&lang=js"
export * from "./CampaignSetupsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports